import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Checkbox from "components/forms/inputs/checkbox";
import Col from "components/grid/col";
import FieldGrid from "components/grid/field-grid";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import Line from "components/layout/line";
import { buildDefaultValues, buildAdminValidationSchema } from "lib/entity";
import { FormSubmitFunction } from "lib/form";
import { ListEntity } from "models/list-entity";
import { ListEntityField } from "models/list-entity-field";
import { EntityCollection } from "models/list-user-entity-collection";
import { EntityCollectionValue } from "models/list-user-entity-collection-value";
import { Fragment, FunctionComponent } from "react";
import { useForm } from "react-hook-form";

interface EntityFormProps {
  listEntity: ListEntity;
  listEntityFields: ListEntityField[];
  entityCollection?: EntityCollection;
  entityCollectionValues?: EntityCollectionValue[];
  onClose: () => Promise<void>;
  onSubmit: FormSubmitFunction;
}

const EntityForm: FunctionComponent<EntityFormProps> = ({
  listEntity,
  listEntityFields,
  entityCollection,
  entityCollectionValues = [],
  onSubmit,
  onClose,
}) => {
  const schema = buildAdminValidationSchema(listEntityFields);
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      // secret is carried over, but only used if the list entity is "multi = true"
      secret: entityCollection ? entityCollection.secret : false,
      ...buildDefaultValues(listEntityFields, entityCollectionValues),
    },
  });

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton },
  ];

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <FieldGrid listEntityFields={listEntityFields} />
      {listEntity.multi && (
        <Fragment>
          <Line />
          <Grid>
            <Row>
              <Col>
                <Checkbox name="secret" label="Pidä tämä tieto salaisena" />
              </Col>
            </Row>
          </Grid>
        </Fragment>
      )}
      <FormButtons buttons={buttons} />
    </Form>
  );
};

export default EntityForm;
